import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function OfferSection() {
  return <Section bg="white" className="pb-24" data-id="element-110">
      <div className="max-w-4xl mx-auto bg-navy rounded-[2.5rem] p-8 md:p-12 text-white shadow-2xl relative overflow-hidden" data-id="element-111">
        {/* Decorative background */}
        <div className="absolute top-0 right-0 w-full h-full bg-[radial-gradient(circle_at_top_right,rgba(212,160,23,0.15)_0,transparent_60%)]" data-id="element-112"></div>

        <div className="relative z-10 grid md:grid-cols-2 gap-12 items-center" data-id="element-113">
          <div id="offer-section" className="order-2 md:order-1" data-id="element-114">
            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-115">
              Recupera el control de tu hogar hoy mismo.
            </h2>
            <p className="text-white/80 text-lg mb-8 leading-relaxed" data-id="element-116">
              Por menos de lo que cuesta un juguete de goma de buena calidad,
              puedes obtener el sistema completo que salvará tu cordura y tus
              muebles.
            </p>

            <div className="bg-white/10 rounded-2xl p-6 mb-8 border border-white/20 backdrop-blur-sm" data-id="element-117">
              <p className="text-sm text-white/60 uppercase tracking-wider mb-2 font-medium" data-id="element-118">
                Oferta Especial por Tiempo Limitado
              </p>
              <div className="flex items-baseline gap-3" data-id="element-119">
                <span className="text-2xl text-white/40 line-through" data-id="element-120">
                  $27.00
                </span>
                <span className="text-5xl font-bold text-amber" data-id="element-121">$6.59</span>
                <span className="text-xl text-white/60" data-id="element-122">USD</span>
              </div>
              <span className="inline-block mt-2 bg-softred text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full" data-id="element-123">
                76% de descuento
              </span>
              <p className="mt-2 text-white/80 font-medium" data-id="element-124">
                Obtén El Protocolo del Hogar Silencioso
              </p>
            </div>

            <Button href="https://floctiva.com/cart/52996565762364:1" className="w-full py-5 text-lg" data-id="element-125">
              ¡QUIERO EL PROTOCOLO AHORA!
            </Button>
            <p className="text-center mt-4 text-sm text-white/50" data-id="element-126">
              Acceso inmediato tras la compra. Tu primera noche de paz comienza
              hoy.
            </p>
          </div>

          <div className="order-1 md:order-2 relative" data-id="element-127">
            <div className="absolute inset-0 bg-amber/20 blur-3xl rounded-full" data-id="element-128"></div>
            <img src="https://cdn.magicpatterns.com/uploads/rsTY7s18hzBkWPdQEwiBGh/heylloyd-image-1776625792775.png" alt="El Protocolo del Hogar Silencioso" className="w-full h-auto rounded-2xl relative z-10 shadow-xl border border-white/10 rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-129" />
          </div>
        </div>
      </div>
    </Section>;
}